import styled from 'styled-components';

import { InterwillAssetDiagnosticCard } from '@/_pages/interwill/components/DiagnosticCards/AssetDiagnosticCard';
import { InterwillBeneficiaryDiagnosticCard } from '@/_pages/interwill/components/DiagnosticCards/BeneficiaryDiagnosticCard';
import { InterwillDocumentDiagnosticCard } from '@/_pages/interwill/components/DiagnosticCards/DocumentDiagnosticCard';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';

export const DiagnosticCards = () => {
  return (
    <DiagnosticCardsWrapper>
      <InterwillAssetDiagnosticCard onCreatePress={() => {}} />

      <InterwillBeneficiaryDiagnosticCard onCreatePress={() => {}} />

      <InterwillDocumentDiagnosticCard onCreatePress={() => {}} />
    </DiagnosticCardsWrapper>
  );
};

const DiagnosticCardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;

  flex-direction: row;
  padding: 12px;
  font-size: 14px;

  pointer-events: none;

  & > div {
    border: 1px solid ${COLORS.systemDark100};
  }

  ${media.iwMobile} {
    flex-direction: column;
  }
`;
